import { OntarioOperationTaxes } from '../operation-taxes'

export const OperationTaxes = {
  ...OntarioOperationTaxes,
} as const
